import { RegulatoryReportType } from 'src/app/core/models/reports';

type ReportTypeMeta = {
  deadlineRuleId: string;
  icon: {
    material: string;
    svg: string;
  };
};

const REPORT_TYPE_META = {
  dcr: {
    deadlineRuleId: 'dcr',
    icon: {
      material: 'description',
      svg: 'assets/images/report-imgs/invv.svg',
    },
  },
  bafin: {
    deadlineRuleId: 'bafin-annex-iv',
    icon: {
      material: 'shield',
      svg: 'assets/images/report-imgs/bafin.svg',
    },
  },
  z4: {
    deadlineRuleId: 'z4',
    icon: {
      material: 'bar_chart',
      svg: 'assets/images/report-imgs/z4.svg',
    },
  },
  quarterly: {
    deadlineRuleId: 'quarterly-lp-report',
    icon: {
      material: 'event_note',
      svg: 'assets/images/report-imgs/quaterly.svg',
    },
  },
} as const satisfies Record<RegulatoryReportType, ReportTypeMeta>;

export const REPORT_TYPE_TO_DEADLINE_RULE_ID = Object.fromEntries(
  Object.entries(REPORT_TYPE_META).map(([reportType, meta]) => [
    reportType,
    meta.deadlineRuleId,
  ])
) as Record<RegulatoryReportType, string>;

const DEADLINE_RULE_ID_TO_REPORT_TYPE = Object.fromEntries(
  Object.entries(REPORT_TYPE_META).map(([reportType, meta]) => [
    meta.deadlineRuleId,
    reportType,
  ])
) as Record<string, RegulatoryReportType>;

export function reportTypeForDeadlineRule(ruleId: string): RegulatoryReportType {
  return DEADLINE_RULE_ID_TO_REPORT_TYPE[ruleId] ?? 'z4';
}

export const REPORT_TYPE_ICONS = Object.fromEntries(
  Object.entries(REPORT_TYPE_META).map(([reportType, meta]) => [
    reportType,
    meta.icon,
  ])
) as Record<RegulatoryReportType, { material: string; svg: string }>;
